module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/star-8d8e419ea89d05e5b296b4a2c4616ee0.svg";